<template>
  <a v-translate
     :class="applyBtnClasses"
     :disabled="loading"
     @click.stop="handleApplyBtnClick()">
    Apply
  </a>
</template>

<script>

import {debounce} from 'lodash';
import {mapGetters} from 'vuex';

export default {
  props: {
    recommendedJobId: String,
    jobCode: String
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapGetters(['jobsContainerIdState']),
    applyBtnClasses() {
      return ['button button-apply is-primary-ghost-small', {'is-loading': this.loading}];
    }
  },
  methods: {
    toogleLoading() {
      this.loading = !this.loading;
    },
    handleApplyBtnClick() {
      this.toogleLoading();
      this.$mam.trackApplyToJobClicked();
      this.$store
        .dispatch('createJobApplicationForRecommendedJobActionByTime', {
          recommendedJobId: this.recommendedJobId,
          code: this.jobCode
        })
        .then(() => {
          this.getRecommendedJobsList();
          this.$toast.open({message: this.$gettext('Applied successfully!'), type: 'is-success', duration: 3000});
        })
        .catch(error => {
          this.$toast.open({message: error, type: 'is-danger', duration: 2000});
        })
        .finally(() => {
          this.toogleLoading();
          if (this.$mq.phone) {
            setTimeout(() => this.$scrollTo(document.getElementById(this.jobsContainerIdState), 200), 400);
          }
        });
    },
    getRecommendedJobsList: debounce(function(data) {
      this.$store.dispatch('getRecommendedJobsListInBackgroundAction');
    }, 300)
  }
};
</script>

<style lang="scss" scoped>
.button-apply {
  min-width: 71px;
}
</style>
